import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContatos } from '../../api/endpoints';
import { fecharModalContato } from '../../app/slices/modalSlice';
import { ReactComponent as TelefonesSvg } from '../../assets/icons/menu/telefones.svg';
import {
  Alerta, Centro, ContainerJanela, Divisor, Linha,
} from '../../styles/base';
import Botao from '../Botao/Botao';
import Carregar from '../Carregar/Carregar';
import {
  BordaContato2, JanelaContato, LinhaContato, TituloContato,
} from './ModalContatoEstilo';
import { selectCidade } from '../../app/slices/cidadesSlice';

const ModalContato = () => {
  const [listaContatos, setListaContatos] = useState(null);

  const dadosCidade = useSelector(selectCidade);

  const dispatch = useDispatch();

  useEffect(() => {
    Promise.all([
      fetchContatos(),
    ]).then(([dadosContatos]) => {
      setListaContatos(dadosContatos);
    });
  }, []);

  const verificarContato = () => {
    if (listaContatos[0].NomeOuvidor) {
      return true;
    }

    if (listaContatos[0].Email01) {
      return true;
    }

    if (listaContatos[0].Email02) {
      return true;
    }

    if (listaContatos[0].Endereco01) {
      return true;
    }

    if (listaContatos[0].HorarioFuncionamentoAte01) {
      return true;
    }

    if (listaContatos[0].HorarioFuncionamentoAte02) {
      return true;
    }

    if (listaContatos[0].HorarioFuncionamentoDe01) {
      return true;
    }

    if (listaContatos[0].HorarioFuncionamentoDe02) {
      return true;
    }

    if (listaContatos[0].Telefone01) {
      return true;
    }

    if (listaContatos[0].Telefone02) {
      return true;
    }

    return false;
  };

  return (
    <ContainerJanela>
      <JanelaContato className="controle-fundo controle-modal">
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fechar
            onClick={() => dispatch(fecharModalContato())}
          />
        </Linha>

        <TituloContato>Contatos</TituloContato>

        <Divisor />

        {(!listaContatos) ? (<Carregar />) : (
          <>
            {!verificarContato() ? (
              <Centro className="controle-fundo">
                <TelefonesSvg
                  style={{
                    height: 180, width: 180,
                  }}
                  fill="#dededd"
                />

                <Divisor />

                <Alerta>Não há nenhum contato cadastrado.</Alerta>
              </Centro>
            ) : (
              <>
                {listaContatos && listaContatos.map((dados) => (
                  <>
                    {dados.NomeOuvidor ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              {
                                dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Cidade && dadosCidade.configuracoes.Cidade === 'Aquiraz' ? (
                                  <b>Ouvidor(a) e Gestor(a) do SIC:</b>
                                ) : (
                                  <b>Ouvidor(a):</b>
                                )
                              }
                              <span>{dados.NomeOuvidor}</span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    ) : null}

                    {dados.Telefone01 ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              {(!dados.Telefone02) ? (<b>Telefone:</b>) : (<b>Telefone principal:</b>)}
                              <span>{dados.Telefone01}</span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    ) : null}

                    {dados.Telefone02 ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              {
                                dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Cidade && dadosCidade.configuracoes.Cidade === 'Aquiraz' ? (
                                  <b>Ramal: </b>
                                ) : (
                                  <b>Telefone secundário: </b>
                                )
                              }
                              <span>{dados.Telefone02}</span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    ) : null}

                    {dados.Email01 ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              {(!dados.Email02) ? (<b>E-mail:</b>) : (<b>E-mail principal:</b>) }
                              <span>{dados.Email01}</span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    ) : null}

                    {dados.Email02 ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              <b>E-mail secundário:</b>
                              <span>{dados.Email02}</span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    ) : null}

                    {dados.Endereco01 ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              {(!dados.Endereco02) ? (<b>Endereço:</b>) : (<b>Endereço principal:</b>)}
                              <span>{dados.Endereco01}</span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    ) : null}
                    {dados.Endereco02 ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              <b>Endereço secundário:</b>
                              <span>{dados.Endereco02}</span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    ) : null}

                    {(dados.HorarioFuncionamentoDe01 && dados.HorarioFuncionamentoAte01) ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              {(!(dados.HorarioFuncionamentoDe02 && dados.HorarioFuncionamentoAte02)) ? (
                                <b>Horário de funcionamento:</b>
                              ) : (
                                <b>Horário de funcionamento da manhã:</b>
                              )}
                              <span>
                                {dados.HorarioFuncionamentoDe01}
                                {' '}
                                até
                                {' '}
                                {dados.HorarioFuncionamentoAte01}
                              </span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    )
                      : (null)}
                    {(dados.HorarioFuncionamentoDe02 && dados.HorarioFuncionamentoAte02) ? (
                      <>
                        <BordaContato2 style={{ width: '100%' }} className="controle-fundo">
                          <LinhaContato>
                            <LinhaContato style={{ maxWidth: '100%' }}>
                              <b>Horário de funcionamento da tarde:</b>
                              <span>
                                {dados.HorarioFuncionamentoDe02}
                                {' '}
                                até
                                {' '}
                                {dados.HorarioFuncionamentoAte02}
                              </span>
                            </LinhaContato>
                          </LinhaContato>
                        </BordaContato2>
                      </>
                    )
                      : (null)}
                  </>
                ))}
              </>
            )}
          </>
        )}
      </JanelaContato>
    </ContainerJanela>
  );
};

export default ModalContato;
